import React from "react";
import DatePicker from "react-datepicker";
import FieldInfoPopover from "./FieldInfoPopover";

function toDateValue(value) {
  const match = String(value || "").match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!match) {
    return null;
  }

  return new Date(Number(match[3]), Number(match[2]) - 1, Number(match[1]));
}

function fromDateValue(value) {
  if (!(value instanceof Date) || Number.isNaN(value.getTime())) {
    return "";
  }

  const day = String(value.getDate()).padStart(2, "0");
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const year = value.getFullYear();

  return `${day}/${month}/${year}`;
}

export default function DateField({
  field,
  required,
  error,
  onChange,
  placeholder,
}) {
  return (
    <div className="col-md-6 mb-md-4">
      <div className={`form-group form-date ${error ? "is-invalid" : ""}`}>
        <label htmlFor={field.id}>
          {required ? <span>*</span> : null}
          {field.title}
        </label>
        <div className={field.labelInfoPopover ? "formHelper" : undefined}>
          <div className="validation-cover">
            <DatePicker
              id={field.id}
              selected={toDateValue(field.value)}
              onChange={(value) => onChange(field.id, fromDateValue(value))}
              dateFormat="dd/MM/yyyy"
              placeholderText={placeholder}
              className="form-control"
              autoComplete="off"
              showPopperArrow={false}
              showIcon
              calendarIconClassName="technical-support-datepicker__icon"
              icon={
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar3" viewBox="0 0 16 16">
                  <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z"/>
                  <path d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
                </svg>
              }

            />
          </div>
          <FieldInfoPopover html={field.labelInfoPopover} />
        </div>
        {field.description ? <div className="mt-2">{field.description}</div> : null}
      </div>
    </div>
  );
}
